import { useMutation } from '@apollo/client';
import { useIntl, defineMessages } from 'react-intl';
import Steven from 'helpers/steven';
import { graphQLIdDecoder } from 'helpers/graphql-utils';
import { getGqlErrors } from '../../helpers';
import toast from 'helpers/toast';
import { SUBTASK_CREATE } from '../graphql/mutations.graphql';
import GET_TASK_LIST_HEADER_INFO from 'components/projects/taskList/gql/getTaskListHeaderInfo.graphql';

const messages = defineMessages({
  error: {
    id: 'Projects.taskList.subTasks.createSubtask.error',
    defaultMessage: 'There was an error creating a question',
    description: 'Default error message for creating a subtask',
  },
});

const useSubtaskCreate = ({ listId }) => {
  const intl = useIntl();

  const [createSubtaskMutation, { loading }] = useMutation(SUBTASK_CREATE, {
    onCompleted: (data) => {
      const gqlErrors = getGqlErrors(data);
      if (gqlErrors.length) {
        toast.error(gqlErrors[0].message);
        return;
      }

      const newSubtaskId = data?.subTaskCreate?.subTask?.id;
      const subtaskDatabaseId = graphQLIdDecoder(newSubtaskId)?.databaseId;

      Steven.entityCrud({
        entity_id: subtaskDatabaseId,
        entity_type: 'checklist_question',
        action: 'created',
      });
    },
    refetchQueries: [
      {
        query: GET_TASK_LIST_HEADER_INFO,
        variables: { id: listId },
      },
    ],
    onError: () => {
      toast.error(intl.formatMessage(messages.error));
    },
  });

  return {
    createSubtask: createSubtaskMutation,
    loading,
  };
};

export default useSubtaskCreate;
